import React from "react";
import Glut1Info from "../components/Glut1Info";
import MeetFamily from "../components/Meetfamily";
import FavoriteMedia from "../components/FavoriteMedia";
import FunFacts from "../components/FunFacts";
import Sports from "../components/Sports";

function About() {
  return (
    <div className="text-center">
      <h2 className="text-4xl font-bold mb-4">Get to know Millie</h2>

    <MeetFamily />
    <FavoriteMedia />
    <FunFacts />
    <Sports />
    <Glut1Info />

    </div>
  );
}

export default About;
